<template>
  <div>
    <v-container
      :class="{
        'px-5': $vuetify.breakpoint.lgAndUp,
      }"
    >
      <div class="row pt-3">
        <div class="col s12 m8 l6">
          <v-card elevation="2" style="border-radius: 10px; padding: 16px">
            <div class="row mb-2">
              <div class="col s8">
                <div style="display: flex; flex-direction: row; gap: 5px">
                  <Typography h4 bold :label="$t('Line Notify')" />
                  <!-- <a
                    href="https://blog.zwiz.ai/line-notify-%E0%B9%81%E0%B8%88%E0%B9%89%E0%B8%87%E0%B9%80%E0%B8%95%E0%B8%B7%E0%B8%AD%E0%B8%99%E0%B8%9C%E0%B9%88%E0%B8%B2%E0%B8%99%E0%B9%84%E0%B8%A5%E0%B8%99%E0%B9%8C/"
                    style="height: 22px"
                  >
                    <img
                      src="/static/img/Info.png"
                      alt
                      class="responsive-img pointer"
                      style="height: 22px"
                    />
                  </a> -->
                </div>
              </div>
              <div class="col s12" style="margin-top: 10px">
                <Typography
                  h6
                  color="color-lightMediumGrey"
                  medium
                  :label="$t('*Chatbot will notify via LINE Notify to connected account.')"
                />
              </div>
              <div class="text-xs-center" v-if="loadingLineNotify"></div>
              <div class="col s12 mt-2 pa-0" v-else style="position: relative; padding: 10px 0px">
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                  style="border-radius: 10px"
                ></v-premium-plan-popup>
                <div
                  class="col s12"
                  v-for="(person, index) in linenotifylist"
                  :key="'line_' + index"
                  style="margin-bottom: 10px"
                >
                  <div class="z-border-notify col s6 pa-0">
                    <v-layout align-center class="pa-2">
                      <v-flex xs10 style="display: flex" class="align-center">
                        <img
                          :src="
                            'https://graph.facebook.com/' + person.adminid + '/picture?type=square'
                          "
                          width="35"
                          height="35"
                          @error="onFailLoad"
                          :alt="person.name"
                          style="border-radius: 50%; margin-right: 10px; float: left"
                        />
                        <div>{{ person.name }}</div>
                      </v-flex>
                      <v-flex
                        xs2
                        text-xs-right
                        v-if="person.adminid == $store.state.userid || getBotPageRole == true"
                      >
                        <div
                          @click="deleteLineNotify(person)"
                          style="display: flex"
                          class="justify-center"
                        >
                          <img
                            src="/static/img/TooltipDelete.png"
                            alt
                            class="responsive-img pointer ma-0"
                            style="height: 24px; width: 24px"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </div>
              <v-btn
                class="mt-2"
                :href="lineNotifyLink"
                :style="`color: ${$vuetify.theme.primary};  text-transform: capitalize;`"
                :color="`color: ${$vuetify.theme.primary}`"
                outline
                ><i class="fas fa-plus mr-1"></i>{{ $t('Link Account') }}</v-btn
              >
              <!-- <template v-if="$store.getters.getPackage == 'premium'">
                <a :href="lineNotifyLink" class="btn btn-outline-red">{{ $t('Link Account') }}</a>
              </template>
              <template v-else>
                <a href="javascript:void(0);" class="btn btn-outline-red">{{
                  $t('Link Account')
                }}</a>
              </template> -->
            </div>
          </v-card>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m8 l6">
          <v-card elevation="2" style="border-radius: 10px; padding: 16px">
            <!-- <div class="pa-2" v-if="linenotifylist && linenotifylist.length > 0"> -->
            <div class="row mb-4">
              <div class="col s8">
                <div style="display: flex; flex-direction: row; gap: 5px">
                  <Typography h4 bold :label="$t('Notification Settings')" />
                </div>
              </div>
              <div class="col s4 right-align">
                <toggle-button
                  :value="isToggleAllNotify"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  @change="onToggleAllNotify()"
                  style="display: inline-block"
                />
              </div>
            </div>

            <v-layout align-center class="mb-2">
              <v-flex xs8>
                <div style="display: flex; flex-direction: row; gap: 5px">
                  <Typography h4 medium :label="$t('All conversation')" />
                </div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    gap: 5px;
                    align-items: center;
                    justify-content: end;
                  "
                >
                  <div
                    v-if="linenotify.notify_intent"
                    @click="showEditLineNotifyConversation = true"
                  >
                    <img
                      src="/static/img/TooltipEdit.png"
                      alt
                      class="responsive-img mt-1 pointer"
                      style="height: 22px"
                    />
                  </div>
                  <toggle-button
                    :value="linenotify.notify_intent"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="onChangeLineNotify('notify_intent')"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </div>
              </v-flex>
            </v-layout>

            <v-layout align-center>
              <v-flex xs8>
                <div style="display: flex; flex-direction: row; gap: 5px">
                  <Typography h4 medium :label="$t('All Comments')" />
                </div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    gap: 5px;
                    align-items: center;
                    justify-content: end;
                  "
                >
                  <div
                    v-if="linenotify.notify_comment"
                    @click="showEditLineNotifyReplyComment = true"
                  >
                    <img
                      src="/static/img/TooltipEdit.png"
                      alt
                      class="responsive-img mt-1 pointer"
                      style="height: 22px"
                    />
                  </div>
                  <toggle-button
                    :value="linenotify.notify_comment"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="onChangeLineNotify('notify_comment')"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </div>
              </v-flex>
            </v-layout>

            <template v-if="$store.state.shoptheme.includes(selectedBot.theme)">
              <v-layout wrap row>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('Notify when customer ordered') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <label
                    class="toggle-switch small"
                    style="margin-top: 10px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      :checked="linenotify.notify_neworder"
                      @change="onChangeLineNotify('notify_neworder')"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </v-flex>
              </v-layout>

              <v-layout wrap row>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('Notify when customer paid') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <label
                    class="toggle-switch small"
                    style="margin-top: 10px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      :checked="linenotify.notify_payment"
                      @change="onChangeLineNotify('notify_payment')"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </v-flex>
              </v-layout>
              <v-layout wrap row>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('Notify when token expired') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <label
                    class="toggle-switch small"
                    style="margin-top: 10px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      :checked="linenotify.notify_token_expired"
                      @change="onChangeLineNotify('notify_token_expired')"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </v-flex>
              </v-layout>
            </template>
            <manage-single-line-notify
              v-if="showEditLineNotifyConversation"
              @close="showEditLineNotifyConversation = false"
            ></manage-single-line-notify>

            <manage-single-line-notify
              type="replycomment"
              v-if="showEditLineNotifyReplyComment"
              @close="showEditLineNotifyReplyComment = false"
            ></manage-single-line-notify>
          </v-card>
        </div>
      </div>
    </v-container>
  </div>
</template>


<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Typography from '@/components/elements/Typography.vue'
import ManageSingleLineNotify from './ManageSingleLineNotify'
import moment from 'moment'
import config from '@/config'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  data: function () {
    return {
      isEdit: false,
      botStatus: false,
      isToggleAllNotify: false,
      loadingLineNotify: true,
      linenotifylist: [],
      showEditLineNotifyConversation: false,
      showEditLineNotifyReplyComment: false,
      linenotify: {
        notify_comment: false,
        notify_intent: false,
        notify_neworder: false,
        notify_payment: false,
        notify_token_expired: false,
      },
    }
  },
  watch: {
    selectedBotStatus() {
      let vm = this
      vm.botStatus = vm.selectedBot.status
    },
  },
  mounted: async function () {
    var vm = this
    vm.botStatus = vm.selectedBot.status
    vm.loadingLineNotify = true
    vm.$store.dispatch('loadSetting')
    try {
      var response = await vm.$store.dispatch('updateBotDetail')
      vm.linenotify = {
        notify_comment: vm.selectedBot.notify_comment,
        notify_intent: vm.selectedBot.notify_intent,
        notify_neworder: vm.selectedBot.notify_neworder,
        notify_payment: vm.selectedBot.notify_payment,
        notify_token_expired: vm.selectedBot.notify_token_expired,
      }
      if (vm.linenotify.notify_comment && vm.linenotify.notify_intent === true) {
        vm.isToggleAllNotify = true
      } else {
        vm.isToggleAllNotify = false
      }
    } catch (error) {}

    vm.loadingLineNotify = false
    vm.getLineNotify()
    await vm.getLineToken()
  },
  components: {
    ManageSingleLineNotify,
    Typography,
    ToggleButton,
  },
  computed: {
    selectedBotStatus() {
      return this.selectedBot.status
    },
    ...mapGetters({
      botlist: 'botlist',
      allPage: 'allPage',
      currentLang: 'currentLang',
      selectedBot: 'selectedBot',
      loadingSetting: 'getLoadingSetting',
    }),
    getBotPageRole: function () {
      var vm = this
      var bot = vm.allPage.find(function (val, index) {
        return val.id == vm.selectedBot.pageid
      })
      if (bot) {
        if (bot.perms) {
          return bot.perms.indexOf('ADMINISTER') > -1
        } else if (bot.tasks) {
          return bot.tasks.indexOf('MANAGE') > -1
        }
      } else {
        return null
      }
    },
    isLinkedLineNotify: function () {
      var vm = this
      if (!vm.selectedBot) {
        return false
      }
      return (
        vm.linenotifylist.findIndex(function (el) {
          return el.pageid == vm.selectedBot.pageid && el.adminid == vm.$store.state.userid
        }) > -1
      )
    },
    lineNotifyLink: function () {
      return (
        `https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=${config.lineNotifyClientId}&redirect_uri=` +
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '') +
        '/linenotify&scope=notify&state=zwizai'
      )
    },
  },
  methods: {
    onToggleAllNotify: function () {
      ;(this.isToggleAllNotify = !this.isToggleAllNotify), this.onChangeAllNotify('notify_comment')
      this.onChangeAllNotify('notify_intent')
    },
    onChangeAllNotify: function (type) {
      this.linenotify[type] = this.isToggleAllNotify
      var data = this.linenotify
      data.pageid = this.selectedBot.pageid
      api.saveLineNotifyNotification(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    },
    onChangeLineNotify: function (type) {
      this.linenotify[type] = !this.linenotify[type]
      var data = this.linenotify
      data.pageid = this.selectedBot.pageid
      api.saveLineNotifyNotification(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    },
    onFailLoad: function () {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    deleteLineNotify: function (person) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to disconnect this account?'),
          type: 'question',
          showCancelButton: true,
          showCloseButton: true,
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteLineNotify(
              { pageid: person.pageid, adminid: person.adminid },
              function (error, response) {
                if (error) {
                  // reject(error)
                }
                var deleteIndex = vm.linenotifylist.findIndex(function (el) {
                  return el.pageid == person.pageid && el.adminid == person.adminid
                })
                if (deleteIndex > -1) {
                  vm.linenotifylist.splice(deleteIndex, 1)
                }
                vm.$store.dispatch('loading')
                // resolve()
              }
            )
          }
        })
    },
    getLineToken: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineToken({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
            vm.$store.dispatch('loading')
          }
          vm.line = {
            line_access_token: response.data.line_access_token,
            line_channel_secret: response.data.line_channel_secret,
            line_channel_id: response.data.line_channel_id,
          }
          resolve()
        })
      })
    },
    getLineNotify: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineNotify({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.linenotifylist) {
            vm.linenotifylist = response.linenotifylist
          }
          resolve()
        })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/view/billing/Notification.vue